export default "__VITE_ASSET__C4ytf6jd__"